import React from 'react';
import { Button } from '../../../components/base/Button';

export const ServicesSection: React.FC = () => {
  const handleWhatsAppClick = () => {
    // Rastreamento Meta Pixel
    if (typeof window !== 'undefined' && (window as any).fbq) {
      (window as any).fbq('track', 'Contact', {
        content_name: 'WhatsApp Serviços',
        content_category: 'Button Click'
      });
    }
    
    window.open('https://wa.me/5585987894357?text=Olá! Gostaria de saber mais sobre os serviços de estamparia digital.', '_blank');
  };

  const servicos = [
    {
      title: 'Impressão Digital',
      description: 'Estamparia digital de alta resolução em diversos tipos de tecido, com cores vibrantes e durabilidade garantida.',
      image: 'https://public.readdy.ai/ai/img_res/d0c46ddf957acaf9b9732a8043815d75.jpg',
      features: ['Alta resolução', 'Cores vibrantes', 'Diversos tecidos', 'Qualidade superior']
    },
    {
      title: 'Estampas Exclusivas',
      description: 'Equipe especializada de designers criando estampas exclusivas com padrão prêmio para seu negócio.',
      image: 'https://static.readdy.ai/image/5d7e5581bdb1497e1b9661cd362300f6/26082dac95b992ecbbee2d781e60b9c6.jpeg',
      features: ['Designers especializados', 'Padrão prêmio', 'Criações exclusivas', 'Consultoria criativa']
    },
    {
      title: 'Produção de Amostras Rápidas',
      description: 'Desenvolvimento rápido de amostras para aprovação antes da produção em larga escala.',
      image: 'https://readdy.ai/api/search-image?query=Quick%20fabric%20sample%20production%20process%2C%20small%20fabric%20samples%20with%20different%20patterns%20and%20colors%2C%20sample%20testing%20and%20quality%20control%2C%20professional%20textile%20laboratory%20environment&width=400&height=300&seq=service3&orientation=landscape',
      features: ['Desenvolvimento rápido', 'Aprovação prévia', 'Diversos padrões', 'Teste de qualidade']
    },
    {
      title: 'Entrega Expressa',
      description: 'Sistema de entrega otimizado com prazos reduzidos, incluindo entrega em até 24 horas.',
      image: 'https://readdy.ai/api/search-image?query=Fast%20delivery%20service%20for%20textile%20products%2C%20delivery%20truck%20with%20textile%20packages%2C%20express%20shipping%20process%2C%20logistics%20and%20distribution%20center%2C%20professional%20delivery%20service&width=400&height=300&seq=service4&orientation=landscape',
      features: ['Entrega 24h', 'Logística otimizada', 'Rastreamento', 'Pontualidade garantida']
    },
    {
      title: 'Atendimento Especializado',
      description: 'Suporte dedicado para marcas, confecções e ateliês com consultoria personalizada.',
      image: 'https://static.readdy.ai/image/5d7e5581bdb1497e1b9661cd362300f6/864f0a732694cdd92ca96b435aac779d.png',
      features: ['Consultoria personalizada', 'Suporte técnico', 'Atendimento dedicado', 'Soluções customizadas']
    }
  ];

  return (
    <section id="servicos" className="py-16 md:py-20 lg:py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16 lg:mb-20">
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 md:mb-6 px-2">Nossos Serviços</h3>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4 leading-relaxed">
              Oferecemos soluções completas em <strong>estamparia digital têxtil</strong>{' '}
              com tecnologia avançada e atendimento personalizado.
            </p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-10 mb-12 md:mb-16">
            {servicos.map((servico, index) => (
              <div key={index} className="bg-gray-50 rounded-2xl md:rounded-3xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className="relative h-48 sm:h-56 md:h-64 overflow-hidden">
                  <img 
                    src={servico.image}
                    alt={`${servico.title} - GMX Fortaleza`}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                  <h4 className="absolute bottom-4 left-4 right-4 text-xl sm:text-2xl md:text-3xl font-bold text-white">{servico.title}</h4>
                </div>
                
                <div className="p-6 md:p-8">
                  <p className="text-sm sm:text-base md:text-lg text-gray-600 mb-5 md:mb-6 leading-relaxed">{servico.description}</p>
                  
                  <div className="grid grid-cols-2 gap-3 md:gap-4">
                    {servico.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center bg-white rounded-lg p-3">
                        <i className="ri-check-fill text-green-500 text-lg mr-2 flex-shrink-0"></i>
                        <span className="text-xs sm:text-sm md:text-base text-gray-700 font-medium">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center">
            <Button 
              onClick={handleWhatsAppClick}
              size="lg"
              icon="ri-whatsapp-fill"
              className="px-8 sm:px-10 md:px-12 py-4 md:py-5 text-base sm:text-lg md:text-xl w-full sm:w-auto shadow-xl hover:scale-105 transform transition-transform"
            >
              Fale Conosco Agora
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
